// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, getWalletScriptUrl } from '../../constants/globalConstants' //, 

import { prorateList, permitRequestPayment, getPermitRequestDetails, getPaymentInitials } from '../../redux/actions/paymentActions'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { Circles } from 'react-loader-spinner'
import { formatYearMonthExpiry, isLoggedIn, isPermissionExist, perkingParkingTime, phoneMasker, restrictInputValues, restrictSpecialChar, sortPortalPermissionByKey, validateCardNumber, validExpiryDate } from '../../utils/helper'
// AllowededTime
import moment from 'moment'
import { getCardDataList } from '../../redux/actions/cardDetailsAction'
import { getConfigDetails } from '../../services/config'
import { handlingPermitServiceCriteria, encryptionHandler, getPartnerDetails, showhideWalletButton, getDeviceType } from '../../utils/helper'
import { addScript } from '../warningCitation/utils/addScript'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import ModalTerm from '../responsiveReservation/termCond'
import ThankYou from '../thankyou/ThankYou'
import CardConnectTokenizer from '../../components/walletButtons/CardConnectTokenizer'
const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
const expirymask = createDefaultMaskGenerator('99/99')
import WalletButtons from '../../components/walletButtons'

function paymentPermitRequest(props) {
  const { guidValue, resValue, dispatch, paymentLoader, partnerDetails, notify } = props
  const [formData, setFormData] = useState()
  const [page, setPage] = useState()
  const [formError, setFormError] = useState()
  const [facility, setFacility] = useState(EMPTY_OBJECT)
  const [prorateResponse, setProrateResponse] = useState(EMPTY_OBJECT)
  const [refractedVehicleList, setRefractedVehicleList] = useState(EMPTY_ARRAY)

  const [card, setCard] = useState()
  const [couponError, setCouponError] = useState('')
  const [coupon, setCoupon] = useState('')
  const [expiry, setExpiry] = useState()
  const [couponRemoveButton, setCouponRemoveButton] = useState()
  const [isCouponApplied, setIsCouponApplied] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isPermitLoading, setIsPermitLoading] = useState(false)
  const [isCardFormVisible, setCardFormVisible] = useState(false)
  const [cardList, setCardList] = useState(EMPTY_ARRAY)
  const [accessPermissions, setAccessPermissions] = useState('')
  // const [loginData, setLoginData] = useState(EMPTY_OBJECT)
  const [isConsent, setIsConsent] = useState(true)
  const [selectedPermit, setSelectedPermit] = useState(EMPTY_ARRAY)
  const [showTerm, setTermShow] = useState(false)

  const [response, setResponse] = useState(EMPTY_OBJECT)
  const [paymentResponse, setPaymentResponse] = useState(false)
  const [paymentStatus, setPaymentStatus] = useState(EMPTY_OBJECT)
  const [cardExpiryMessage, setCardExpiryMessage] = useState('')
  const [isCouponAppliedAdmin, setIsCouponAppliedAdmin] = useState(false)
  const [isCouponLoading, setIsCouponLoading] = useState(false)

  const [permitDataResponce, setPermitDataResponce] = useState(EMPTY_OBJECT)
  const navigate = useNavigate()
  const { permit_id } = useParams()
  const searchParams = new URLSearchParams(location.search)

  const loaded = useRef()
  const applePaySessionRef = useRef(null)
  const [walletButtonShow, setWalletButtonShow] = useState(null)
  const [isIOSDevice, setIsIOSdevice] = useState(false)
  const [walletDisable, setWalletDisable] = useState(false)
  const [currFacility, setCurrFacility] = useState(EMPTY_OBJECT)

  // EOS-973
  const tokenRef = useRef(null)
  const [cardToken, setCardToken] = useState('')
  const [iframeErrorMsg, setIframeErrorMsg] = useState('')
  // EOS-973


  const paymentInitials = (formData) => {
    const facility = localStorage.getItem('facility') ? JSON.parse(localStorage.getItem('facility')) : {}

    const paymentSessionPayload = {
      'permit_rate_id': formData?.permit_rate_id ? Number(formData?.permit_rate_id) : '',
      'license_number': formData?.license_number,
      'facility_id': formData?.facility_id ? Number(formData?.facility_id) : facility?.id ? facility?.id : '',
      'promocode': '',
      'permit_service': formData?.permit_service && formData?.permit_service.length > 0 ? formData?.permit_service : []
    }
    dispatch(getPaymentInitials(paymentSessionPayload)).then((response) => {
      // setUrl(response?.data?.api_url)
      // setRes(response?.data?.ipgSession)
      // setGuid(response?.data?.guid)
      localStorage.setItem('paymentSession', JSON.stringify(response?.data))
    }).catch((err) => {
      console.log('err', err)
      // notify('error', err ? err : 'Something went wrong, Please try again!')
      // setIsLoading(false)
    })
  }

  const getPermitDetails = () => {
    setIsPermitLoading(true)
    dispatch(getPermitRequestDetails(permit_id, searchParams?.get('current_time'))).then((res) => {
      setPermitDataResponce(res)
      let permitdata = res?.data[0]
      let facilityData = permitdata?.facility
      permitdata['name'] = ''
      permitdata['permit_rates'] = res?.data[0]?.permit_rate?.rate//reset permit_rates
      setFormData(permitdata)
      paymentInitials(permitdata)
      let finalVehicleList = []
      permitdata?.permit_vehicle?.map((value) => {
        let vehicleData = value?.vehicle
        if (vehicleData?.license_plate_number) {
          finalVehicleList.push({ 'license_plate': vehicleData?.license_plate_number, 'make': vehicleData?.othermake ? vehicleData?.maketext : vehicleData?.make, 'model': vehicleData?.othermodel ? vehicleData?.modeltext : vehicleData?.model, 'color': vehicleData?.color, 'style': vehicleData?.style, 'state_id': vehicleData?.state_id })
        }
      })
      setRefractedVehicleList(finalVehicleList)
      setIsPermitLoading(false)
      setFacility(facilityData)
      setSelectedPermit(permitdata)
      handleCardShowInZeroAmount(permitdata?.permit_final_amount)
      if (permitdata?.promocode != '' && Number(permitdata?.discount_amount?.replace(',', '')) > 0) {
        setCouponRemoveButton(true)
        setIsCouponApplied(true)
        setIsCouponAppliedAdmin(true)
      }

      localStorage.setItem('facility', JSON.stringify(facilityData))
      localStorage.setItem('permits', JSON.stringify(permitdata?.permit_rate))

    }).catch((err) => {
      console.log('err', err)
      setIsPermitLoading(false)
    })
  }

  const handleLogout = () => {
    localStorage.removeItem('userData')
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('masquerade')

    if (getPartnerDetails()) {
      sessionStorage.setItem('partnerSecret', getConfigDetails()?.CLIENT_SECRET)
      sessionStorage.setItem('partnerData', JSON.stringify(getPartnerDetails()))

    }
    localStorage.removeItem('partnerSecret')
    sessionStorage.removeItem('partnerSecret')
    localStorage.removeItem('partnerData')
    sessionStorage.removeItem('partnerData')
    localStorage.clear()
    localStorage.setItem('isLoggedIn', false)
    // setIsLoggedIn(false)
    // navigate(`${URL?.INDEX}/${getPartnerDetails()?.partner_slug}`)
    navigate(0)

  }

  useEffect(() => {
    if (Number(formData?.permit_final_amount?.replace(',', '')) <= 0) {
      setIsConsent(false)
      formData ? formData['userConsent'] = false : ''
      setFormData({ ...formData })
    } else {
      setIsConsent(true)
      formData ? formData['userConsent'] = true : ''
      setFormData({ ...formData })
    }
  }, [EMPTY_ARRAY, formData?.permit_final_amount])


  useEffect(() => {
    const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
    setAccessPermissions(getAccessPermissionData)
  }, [EMPTY_ARRAY, partnerDetails])

  useEffect(() => {
    getPermitDetails()
    localStorage.setItem('name', '')
    localStorage.setItem('email', '')
    localStorage.setItem('phone', '')
    localStorage.setItem('card_date_expiry_month', '')
    localStorage.setItem('card_date_expiry_year', '')
    localStorage.setItem('card_pan', '')
    localStorage.setItem('CardNumberLast4', '')

    if (isLoggedIn()) {
      handleCardShowInZeroAmount(formData?.permit_final_amount)
      handleLogout()
      setCardFormVisible(false)
      // const facility_id = partnerDetails?.facilities?.[0]?.id
      // if (facility_id) {
      dispatch(getCardDataList()).then((res) => {
        if (res?.data) {
          // setCardList(res?.data?.payments)
          setCardList(EMPTY_ARRAY)
          setIsLoading(false)
        }
      }).catch(() => {
        setIsLoading(false)
      })
      // }

    } else {
      setCardFormVisible(true)
      handleCardShowInZeroAmount(formData?.permit_final_amount)
    }
    const deviceType = getDeviceType()
    setIsIOSdevice(deviceType)
  }, [EMPTY_ARRAY])

  // Load Wallet Payment Script
  useEffect(() => {
    // Load Wallet Payment Script
    if (facility?.id) {
      const curFacility = partnerDetails?.facilities.filter((item) => {
        return item?.id == facility?.id
      })
      const paymentGateway = curFacility?.[0]?.facility_payment_details?.facility_payment_type_id
      const applePayScript = getWalletScriptUrl(paymentGateway)
      Object.values(applePayScript)?.map((item) => {
        if (item) {
          addScript(loaded, item, '')
        }
      })
      const getWalletPermission = isPermissionExist(accessPermissions, 'Enable A/G Pay - Permit')
      setWalletButtonShow(showhideWalletButton(curFacility?.[0]) && getWalletPermission)
      setWalletDisable(false)
      setCurrFacility(curFacility?.[0])
    }
    // Load Wallet Payment Script
  }, [EMPTY_ARRAY, facility])

  const getVals = () => {
    return formData
  }

  const closeApplePaySession = (endsession) => {
    if (applePaySessionRef.current) {
      if (endsession === 'success') {
        applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_SUCCESS)
      } else if (endsession === 'failed') {
        applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_FAILURE)
      } else {
        applePaySessionRef.current.abort()
      }
    }
  }

  const handleCardChange = (value) => {
    setCard(value?.trim())
    formData['card_pan'] = value?.trim()
    setFormData({ ...formData })
  }

  const handleCardSelectChange = (e) => {
    const { value } = e.target
    const selectedCard = cardList?.filter((card) => card?.payment_profile_id == value)

    setFormData({ ...formData, ['payment_profile_id']: selectedCard[0]?.payment_profile_id })

  }

  const handleAcknowledge = (e) => {
    const { name, checked } = e.target
    setFormData({ ...formData, [name]: checked })
  }

  const showCardForm = () => {
    setCardFormVisible(true)
    setFormData({ ...formData, ['payment_profile_id']: '' })
  }

  const hideCardForm = () => {
    setCardFormVisible(false)
    setFormData({ ...formData, ['payment_profile_id']: '' })
  }

  const handleCardShowInZeroAmount = (finalAmount) => {
    if (finalAmount && Number(finalAmount?.replace(',', '')) == 0 || cardList?.length > 0) {
      setCardFormVisible(false)
    } else {
      setCardFormVisible(true)
    }
  }

  useEffect(() => {
    setPage('paymentPermitRequest')
  }, [EMPTY_ARRAY])

  const handleInputFieldsData = (e, i, perItem) => {
    const { name, value } = e.target
    if (name == 'permit_rate') {
      formData['permit_rate'] = perItem?.rate
      formData['permit_rate_id'] = perItem?.id
      setFormData({ ...formData })
      setFormData({ ...formData, ['permit_rate']: value })
      // const facility = JSON.parse(localStorage.getItem('facility'))

      const proRatePayload = {
        facility_id: facility?.id,
        driving_license: formData?.license_number,
        permit_rate_id: perItem?.id
      }
      dispatch(prorateList(proRatePayload)).then((res) => {
        setIsCouponApplied(false)
        formData['processing_fee'] = res?.data?.processing_fee
        formData['permit_rate'] = perItem?.rate
        formData['permit_rate_id'] = perItem?.id
        formData['processing_fee'] = res?.data?.processing_fee
        formData['net_parking_amount'] = res?.data?.net_parking_amount
        // formData['coupon_applied'] = false
        setFormData({ ...formData })
        setProrateResponse(res?.data)
        handleCardShowInZeroAmount(formData?.permit_final_amount)
      })
    } else if (name == 'promocode') {
      setCoupon(value)
    }
    setFormData({ ...formData, [name]: value })
  }

  const handleConsentChange = (e) => {
    const { name, checked } = e.target
    setIsConsent(!isConsent)
    setFormData({ ...formData, [name]: checked })
  }

  const handleCouponRemove = () => {
    setCouponError('')
    setCoupon('')
    setCouponRemoveButton(false)
    // const facility = JSON.parse(localStorage.getItem('facility'))
    // const permits = JSON.parse(localStorage.getItem('permits'))
    const facility = selectedPermit?.facility
    const permits = selectedPermit?.permit_rate

    const payLoadData = {
      is_guest: isLoggedIn() ? '0' : '1',
      facility_id: facility?.id,
      driving_license: formData?.license_number,
      permit_service: formData?.permit_service ? formData?.permit_service : [],
      permit_rate_id: permits?.id
    }
    dispatch(prorateList(payLoadData)).then((res) => {
      setCouponError('')
      setIsCouponApplied(false)
      setProrateResponse(res?.data)
      formData['is_guest'] = isLoggedIn() ? '0' : '1'
      formData['processing_fee'] = res?.data?.processing_fee
      formData['permit_rate'] = res?.data?.base_rate
      formData['coupon_applied'] = false
      formData['promocode'] = ''
      formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
      formData['discount_amount'] = 0
      formData['permit_rates'] = res?.data?.base_rate ? res?.data?.base_rate : formData?.permit_rates
      formData['net_parking_amount'] = res?.data?.net_parking_amount
      setFormData({ ...formData })
      handleCardShowInZeroAmount(formData?.permit_final_amount)
    })
  }

  const handleCouponCode = () => {
    if (coupon?.trim()) {
      setCouponRemoveButton(true)
      setCouponError('')
      setIsCouponLoading(true)
      setIsCouponApplied(true)
      setCoupon(coupon)
      // const facility = JSON.parse(localStorage.getItem('facility'))
      // const permits = JSON.parse(localStorage.getItem('permits'))
      const facility = selectedPermit?.facility
      const permits = selectedPermit?.permit_rate
      const proRate = {
        is_guest: isLoggedIn() ? '0' : '1',
        facility_id: facility?.id,
        driving_license: formData?.license_number,
        permit_rate_id: permits?.id,
        promocode: coupon,
        client_id: getConfigDetails()?.CLIENT_SECRET,
        email: formData?.email,
        phone: formData?.phone,
        permit_service: formData?.permit_service ? formData?.permit_service : [],
        license_plate: refractedVehicleList?.[0]?.license_plate,
      }
      dispatch(prorateList(proRate)).then((res) => {
        if (res?.data) {
          setIsCouponLoading(false)
          setIsCouponApplied(true)
          formData['permit_rate'] = res?.data?.base_rate
          formData['processing_fee'] = res?.data?.processing_fee
          formData['coupon_applied'] = true
          formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
          formData['discount_amount'] = res?.data?.promocode_discount_amount ? res?.data?.promocode_discount_amount : formData?.discount_amount
          formData['permit_rates'] = res?.data?.base_rate ? res?.data?.base_rate : formData?.permit_rates
          formData['net_parking_amount'] = res?.data?.net_parking_amount
          setFormData({ ...formData })
          setProrateResponse(res?.data)
          handleCardShowInZeroAmount(formData?.permit_final_amount)

        } else {
          setIsCouponLoading(false)
          setCouponError(res?.errors?.message)
          // const facility = JSON.parse(localStorage.getItem('facility'))
          // const permits = JSON.parse(localStorage.getItem('permits'))
          const facility = selectedPermit?.facility
          const permits = selectedPermit?.permit_rate


          const payLoadData = {
            facility_id: facility?.id,
            driving_license: formData?.license_number,
            permit_rate_id: permits?.id,
            permit_service: formData?.permit_service ? formData?.permit_service : [],
          }
          dispatch(prorateList(payLoadData)).then((res) => {
            setIsCouponApplied(false)
            formData['is_guest'] = isLoggedIn() ? '0' : '1'
            formData['processing_fee'] = res?.data?.processing_fee
            formData['permit_rate'] = res?.data?.base_rate
            formData['coupon_applied'] = false
            formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
            formData['discount_amount'] = res?.data?.promocode_discount_amount ? res?.data?.promocode_discount_amount : formData?.discount_amount
            formData['permit_rates'] = res?.data?.base_rate ? res?.data?.base_rate : formData?.permit_rates
            formData['net_parking_amount'] = res?.data?.net_parking_amount
            setFormData({ ...formData })
            setProrateResponse(res?.data)
            handleCardShowInZeroAmount(formData?.permit_final_amount)

          })

        }

      }).catch((error) => {
        setCouponError(error?.errors?.message)
        setCoupon('')
        setCouponRemoveButton(false)
        // const facility = JSON.parse(localStorage.getItem('facility'))
        // const permits = JSON.parse(localStorage.getItem('permits'))
        const facility = selectedPermit?.facility
        const permits = selectedPermit?.permit_rate

        const payLoadData = {
          facility_id: facility?.id,
          driving_license: formData?.license_number,
          permit_service: formData?.permit_service ? formData?.permit_service : [],
          permit_rate_id: permits?.id
        }
        dispatch(prorateList(payLoadData)).then((res) => {
          setIsCouponApplied(false)
          formData['is_guest'] = isLoggedIn() ? '0' : '1'
          formData['processing_fee'] = res?.data?.processing_fee
          formData['permit_rate'] = res?.data?.base_rate
          formData['coupon_applied'] = false
          formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
          formData['discount_amount'] = null
          formData['permit_rates'] = res?.data?.base_rate ? res?.data?.base_rate : formData?.permit_rates
          formData['net_parking_amount'] = res?.data?.net_parking_amount
          setFormData({ ...formData })
          setProrateResponse(res?.data)
          handleCardShowInZeroAmount(formData?.permit_final_amount)

        })
        setIsCouponLoading(false)
        setIsCouponApplied(false)
        formData['coupon_applied'] = false

      })
    } else {
      setCouponError('Please enter a valid promocode')
      setCoupon('')
      setCouponRemoveButton(false)
      // const facility = JSON.parse(localStorage.getItem('facility'))
      // const permits = JSON.parse(localStorage.getItem('permits'))
      const facility = selectedPermit?.facility
      const permits = selectedPermit?.permit_rate

      const payLoadData = {
        facility_id: facility?.id,
        driving_license: formData?.license_number,
        permit_service: formData?.permit_service ? formData?.permit_service : [],
        permit_rate_id: permits?.id
      }
      dispatch(prorateList(payLoadData)).then((res) => {
        setIsCouponApplied(false)
        // formData['permit_rate'] = res?.data?.total_amount
        // formData['coupon_applied'] = false
        formData['is_guest'] = isLoggedIn() ? '0' : '1'
        formData['processing_fee'] = res?.data?.processing_fee
        formData['permit_rate'] = res?.data?.base_rate
        formData['coupon_applied'] = false
        formData['discount_amount'] = null
        formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount

        formData['permit_rates'] = res?.data?.base_rate ? res?.data?.base_rate : formData?.permit_rates
        setFormData({ ...formData })
        setProrateResponse(res?.data)
        handleCardShowInZeroAmount(formData?.permit_final_amount)
      })
      setIsCouponLoading(false)
      setIsCouponApplied(false)
      formData['coupon_applied'] = false

    }

  }

  const handleModalTerm = () => {
    setTermShow(!showTerm)
  }

  const handleExpiryChange = (value) => {

    let expiryDateCheck = validExpiryDate(value)
    if (value.length == 4 && !expiryDateCheck) {
      // notify('error', 'Please Enter a valid expire date')
      setCardExpiryMessage('Enter a valid expire date')
      // setExpiry('')
      // formData['expiration_date'] = ''
      // setFormData({ ...formData })
    } else {
      setCardExpiryMessage('')
      setExpiry(value?.trim())
      formData['expiration_date'] = value?.trim()
      setFormData({ ...formData })

    }

  }

  const handleSubmit = (formData) => {
    if (!isLoading) {
      // if (formData?.userAcknowledge) {

      let permit_final_amount = formData?.permit_final_amount ? Number(formData?.permit_final_amount.replace(',', '')) : ''

      // if (Object.values(formData).length > 0 && (formData?.payment_profile_id || (formData?.card_pan && formData?.name && formData?.card_date_expiry_month && formData?.card_date_expiry_year && formData?.card_card_security_cvx_2 && formData?.zip_code)) || formData?.permit_rate == '0.00') {
      if ((Object.values(formData).length > 0 && ((cardToken && cardToken?.token && !iframeErrorMsg) || formData?.payment_profile_id || (formData?.card_pan && formData?.name && formData?.expiration_date && (formData?.expiration_date?.length > 3 && formData?.expiration_date?.length < 6) && formData?.card_card_security_cvx_2)) || (permit_final_amount == '0.00') || formData?.walletPay) && (!isPermissionExist(accessPermissions, 'Display Terms & Conditions') || (isPermissionExist(accessPermissions, 'Display Terms & Conditions') && formData?.userAcknowledge))) {

        setIsLoading(true)
        // const userData = JSON.parse(localStorage.getItem('userData'))
        // const paymentSessionValue = JSON.parse(localStorage.getItem('paymentSession'))
        let nonce
        if (!formData?.payment_profile_id && (formData?.payment_profile_id == '' || formData?.payment_profile_id == undefined || formData?.payment_profile_id == null)
          && ((formData?.name && formData?.card_pan && formData?.expiration_date && formData?.card_card_security_cvx_2) || (cardToken && cardToken?.token && !iframeErrorMsg))
        ) {
          // if (!formData?.payment_profile_id && (formData?.payment_profile_id == '' || formData?.payment_profile_id == undefined || formData?.payment_profile_id == null)
          //   && (formData?.name_on_card && formData?.card_pan && formData?.card_date_expiry_month && formData?.card_date_expiry_year && formData?.card_card_security_cvx_2 && formData?.zip_code)
          // ) {

          // const card_expiration_date = formData?.card_date_expiry_month + formData?.card_date_expiry_year
          if (facility?.facility_payment_details?.facility_payment_type_id == '3' && cardToken && cardToken?.token) {
            // For Fiserv, use cardToken to create payment data
            let card = {
              name_on_card: formData?.name || '',
              card_number: cardToken?.token || '',
              expiration_date: formatYearMonthExpiry(cardToken?.expiry),
              security_code: '',
            }
            if (cardToken?.zip_code) {
              card.zip_code = cardToken?.zip_code
            }
            nonce = encryptionHandler(card)

          } else {
            const card_expiration_date = formData?.expiration_date
            let cardData = {
              name_on_card: formData?.name,
              card_number: formData?.card_pan ? formData?.card_pan.replace(/\D/g, '') : '',
              expiration_date: card_expiration_date ? card_expiration_date.replace(/\D/g, '') : '',
              security_code: formData?.card_card_security_cvx_2
            }
            if (formData?.zip_code) {
              cardData.zip_code = formData?.zip_code
            }
            nonce = encryptionHandler(cardData)
          }
        } else {
          if (iframeErrorMsg && iframeErrorMsg != '') {
            notify('error', iframeErrorMsg)
          }
        }
        let finalVehicleList = []
        formData?.vehicleList?.map((value) => {
          if (value?.license_plate) {
            finalVehicleList.push({ 'license_plate': value?.license_plate, 'make': value?.othermake ? value?.maketext : value?.make, 'make_id': value?.vehicleList.length > 1 ? value?.vehicleList[1].make_id : 0, 'model': value?.othermodel ? value?.modeltext : value?.model, 'color': value?.color, 'state_id': value?.state_id, 'vehicle_number': value?.vehicle_number })
          }
        })
        let formPostData = new FormData()    //formdata object
        //let driverName=[]
        let driverListData = formData?.driver

        for (let i = 0; i < driverListData?.length; i++) {
          // driverName.push(driverList[i]?.driver_name)
          formPostData.append(`driver_signature${i}`, driverListData[i]?.driver_signature)
        }
        formPostData.append('user_consent', formData?.userConsent ? formData?.userConsent == true ? 1 : 0 : 0)
        formPostData.append('processing_fee', formData?.processing_fee ? formData?.processing_fee : '')
        if (formData?.walletPay) {
          if (isIOSDevice) {
            formPostData.append('walletPay', JSON.stringify(formData?.walletPay ? formData?.walletPay : '')) //Issue in mac only
          } else {
            formPostData.append('walletPay', formData?.walletPay ? formData?.walletPay : '')
          }
          formPostData.append('paymentMethods', formData?.paymentMethods ? formData?.paymentMethods : '')
        } else {
          formPostData.append('nonce', nonce ? nonce : '')
        }
        formPostData.append('amount', formData?.negotiated_amount && Number(formData?.negotiated_amount) > 0 ? (formData?.negotiated_amount) : formData?.permit_final_amount)
        formPostData.append('promocode', formData?.coupon_applied == true ? formData?.promocode ? formData?.promocode : '' : '')
        formPostData.append('discount_amount', formData?.discount_amount ? formData?.discount_amount : '')

        formPostData.append('is_admin', 0)
        formPostData.append('is_payment_authrize', '1')
        formPostData.append('permit_id', permit_id)

        localStorage.setItem('bookingType', 'Permit')

        if (formData?.net_parking_amount) {
          formPostData.append('net_parking_amount', formData?.net_parking_amount)
        }
        if (formData?.surcharge_fee) {
          formPostData.append('surcharge_fee', formData?.surcharge_fee)
        }
        if (formData?.tax_fee) {
          formPostData.append('tax_fee', formData?.tax_fee)
        }
        if (formData?.additional_fee) {
          formPostData.append('additional_fee', formData?.additional_fee)
        }
        // dispatch(saveBookingBeforePayment(beforePaymentPayload)).then((response) => {
        dispatch(permitRequestPayment(formPostData)).then((response) => {
          const responseData = response?.data
          // localStorage.setItem('responseData-before-api', JSON.stringify(responseData))               
          if (responseData) {
            setIsLoading(false)
            setPaymentResponse(responseData)
            setPaymentStatus(true)
            const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
            if (userDetailsFromLocal?.access_token) {
              if (responseData?.error_msg && responseData?.error_msg != '') {
                setResponse(responseData?.error_msg)
                const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                userDetailsFromLocal.user = responseData?.userDetails
                // const userData = responseData?.userDetails
                if (userDetailsFromLocal) {
                  localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                } else {
                  localStorage.setItem('userData', '{}')
                }
                setPage('thankyou')
                closeApplePaySession('failed')
              } else {
                const userData = responseData?.userDetails
                if (userData) {
                  const userDetailsFromLocal = JSON.parse(localStorage.getItem('userData'))
                  userDetailsFromLocal.user = userData
                  localStorage.setItem('userData', JSON.stringify(userDetailsFromLocal))
                } else {
                  localStorage.setItem('userData', '{}')
                }
                setResponse(response)
                setPage('thankyou')
                closeApplePaySession('success')
              }
            } else {
              if (responseData?.error_msg && responseData?.error_msg != '') {
                setResponse(responseData?.error_msg)
                const userData = responseData?.userDetails
                if (userData) {
                  localStorage.setItem('userData', JSON.stringify(userData))
                } else {
                  localStorage.setItem('userData', '{}')
                }
                setPage('thankyou')
                closeApplePaySession('failed')
              } else {

                const userData = responseData?.userDetails

                if (userData) {

                  localStorage.setItem('userData', JSON.stringify(userData))

                } else {
                  localStorage.setItem('userData', '{}')
                }
                setPage('thankyou')
                setResponse(response)
                closeApplePaySession('success')
              }
            }

          } else {
            closeApplePaySession('failed')
            setIsLoading(false)

            const errors = response?.errors
            setResponse(errors ? errors?.message : 'Something went wrong, Please try again!')
            //old                  
            if (errors?.message == 'Invalid password.' || !response?.message || response?.message == '' || response?.message == undefined || response?.message == null) {
              // setPreviousActive(true)
            } else {
              // setPreviousActive(false)
            }
            setIsLoading(false)
            setPaymentStatus(false)
            setPage('thankyou')
          }
          // formRef.current = false
        }).catch((err) => {
          closeApplePaySession('failed')
          setResponse(err ? err : 'Something went wrong, Please try again!')
          //old                  
          setIsLoading(false)
          setPage('thankyou')
        })
        // .catch((error) => { 
        //     formRef.current = false
        //     const ErrorMsg = error?.errors                   
        //     setResponse(ErrorMsg?.message ? ErrorMsg?.message : error)               
        //     setPage('thankyou')
        // })                       

      } else {
        if (iframeErrorMsg && iframeErrorMsg != '') {
          notify('error', iframeErrorMsg)
        }
        setIsLoading(false)
        setFormError('paymentPermitRequest')
      }
      // } else {
      //   setFormError('paymentPermitRequest')
      // }
    }
  }

  return (
    <div className={`container mt-5 min-h-box ${!permitDataResponce?.data ? 'noform' : ''}`} id="qbox-container">

      <div className="row justify-content-center">
        {isPermitLoading ?
          <span className='ms-6 d-flex justify-content-center loaderdesign section dashboard'><Circles
            height="700"
            width="50"
            color="var(--bs-primary)"
            ariaLabel="circles-loading"
            visible={true}
          /></span> :
          <div className="col-md-10">

            <form id='ipg_form' target="_top" name='ipg_form' method='post' onSubmit={() => handleSubmit(formData)}>
              <h4 className="my-4 text-center titleHeading ">{permitDataResponce?.data ? page == 'paymentPermitRequest' ? 'Please complete the payment for your Permit request' : '' : permitDataResponce?.errors?.message}</h4>

              {page == 'paymentPermitRequest' && permitDataResponce?.data ?
                <div>
                  <ModalTerm partnerDetails={partnerDetails} facilityId={formData?.facility_id} setShow={setTermShow} show={showTerm} />

                  <div className="card">
                    <div className="row g-0">
                      <div className="col">
                        <div className="card-header fw-bold">
                          Basic Information
                        </div>
                        <div className="card-body">
                          <p className="mb-1"><b>Name :</b>  {formData?.user?.name} </p>
                          <p className="mb-1"><b>Email :</b>  {formData?.user?.email}</p>
                          <p className="mb-0"><b>Phone Number :</b> {phoneMasker(formData?.phone)}</p>
                          {formData?.reserved_space_number ? <p className="mb-0"><b>Preferred Reserved Space Number :</b> {formData?.reserved_space_number}</p> : ''}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="bg-primary p-2 bg-primary bg-opacity-10">
                    <div className="row ">
                      <div className="col-12 d-flex">
                        <table className='w-100'>

                          {refractedVehicleList?.map((vehicle, i) => {
                            return (
                              <tr className='row' key={i}>
                                <td className='col'><b>License plate number :</b> {vehicle?.license_plate ? vehicle?.license_plate : '-'}</td>
                                {isPermissionExist(accessPermissions, 'Get Permit By Email') ? <td className='col'><b>Make :</b> {(vehicle?.make) ? `${vehicle?.make}` : '-'}</td> :
                                  <td className='col'><b>Make / Model: </b> {(vehicle?.make && vehicle?.model) ? `${vehicle?.make}/${vehicle?.model}` : '-'}</td>}
                                <td className='col'><b>Color :</b> {vehicle?.color ? vehicle?.color : '-'}</td>
                                {isPermissionExist(accessPermissions, 'Get Permit By Email') ? <td className='col'><b>Style :</b> {vehicle?.style ? vehicle?.style : '-'}</td> : null}

                              </tr>
                            )
                          })}
                        </table>
                      </div>
                    </div>
                  </div>
                  {formData?.authorized_driver?.length > 0 && <div className="bg-primary p-2 bg-primary bg-opacity-10">
                    <div className="row ">
                      <div className="col-12 d-flex">
                        <table className='w-100'>

                          {formData?.authorized_driver?.map((v, i) => {
                            return (
                              <tr className='row align-items-center' key={i}>
                                <td className='col'><b>Driver Name :</b> {v?.driver_name ? v?.driver_name : '-'}</td>
                                <td className='col'>
                                  <div className="d-flex align-items-center">
                                    <b> Document: &nbsp;</b>
                                    {v?.signature_name ? <div className='border'><img style={{ maxHeight: '100px', maxWidth: '200px' }} src={URL.createObjectURL(v?.url)} alt="Preview" /></div> : '-'}
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </table>
                      </div>
                    </div>
                  </div>}


                  {/* NEW DESIGN */}


                  <div className="card  my-3">
                    {/*  price section garage info started */}
                    <div className='bg-light p-3'>
                      {isPermissionExist(accessPermissions, 'Hide Facility') ? null : <h4 className="text-primary fw-bold mb-1">{selectedPermit?.facility?.full_name}</h4>}
                      <div className='row  justify-content-between g-2'>
                        <div className='col-sm col-12'>
                          {/* HIDING FACILITY DETAILS AND DISPLAYING PERMIT TIME VALIDATION TO SYNC DESIGN */}
                          {isPermissionExist(accessPermissions, 'Hide Facility') ? selectedPermit?.permit_rate?.permit_rate_criteria_mapping?.length > 0 ? perkingParkingTime(selectedPermit?.permit_rate, false) : null : <p className="m-0 small"><b className='me-2'>Entrance Address: </b>{`${selectedPermit?.facility?.geolocations?.address_1 ? selectedPermit?.facility?.geolocations?.address_1 : ''}${selectedPermit?.facility?.geolocations?.address_2 ? `, ${selectedPermit?.facility?.geolocations?.address_2}` : ''}${selectedPermit?.facility?.geolocations?.city ? `, ${selectedPermit?.facility?.geolocations?.city}` : ''}${selectedPermit?.facility?.geolocations?.state ? `, ${selectedPermit?.facility?.geolocations?.state}` : ''}${selectedPermit?.facility?.geolocations?.zip_code ? `, ${selectedPermit?.facility?.geolocations?.zip_code}` : ''}`}</p>}
                          {formData?.user_type_id ? <p className='small m-0'><b>Student/Staff/Faculty ID</b><span>
                            - {formData?.user_type_id}</span> </p> : ''}
                        </div>
                        <div className='col-sm-auto col-12 text-sm-end '>
                          <div className='border-top  d-block d-sm-none'></div>
                          <p className='mb-0 small'>  <span className="me-2 fw-bold d-inine-block"> Start Date: - </span>   <span><i className='fa fa-calendar-alt small me-1'></i> {selectedPermit?.desired_start_date ? `${moment(selectedPermit?.desired_start_date, 'YYYY-MM-DD').format('MM/DD/YYYY')}` : ''}</span> </p>
                          <p className='mb-0 small' >  <span className="me-2 fw-bold d-inine-block"> End Date: - </span>    <span><i className='fa fa-calendar-alt small me-1'></i> {selectedPermit?.desired_end_date ? `${moment(selectedPermit?.desired_end_date, 'YYYY-MM-DD').format('MM/DD/YYYY')}` : ''}</span></p>

                        </div>

                        {/* {((facility?.facility_configuration && facility?.facility_configuration?.is_prorate_apply == '0')) ? <div className='col-sm-auto col-12 text-sm-end '>
                          <div className='border-top  d-block d-sm-none'></div>
                          <p className='mb-0 small'>  <span className="me-2 fw-bold d-inine-block"> Start Date: - </span>   <span><i className='fa fa-calendar-alt small me-1'></i> {prorateResponse?.start_date ? `${moment(prorateResponse?.start_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span> </p>
                          <p className='mb-0 small' >  <span className="me-2 fw-bold d-inine-block"> End Date: - </span>    <span><i className='fa fa-calendar-alt small me-1'></i> {prorateResponse?.end_date ? `${moment(prorateResponse?.end_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span></p>

                        </div> : ''
                        } */}


                      </div>
                      {/* IN CASE IF WE ARE HIDING FACILITY, 
                    WE ARE MOVING THIS INFORMATION AT ABOVE DIV, 
                    HENCE HIDING IT FROM HERE ELSE PART WILL DISPLAY IT HERE AND HIDE FROM ABOVE*/}
                      {isPermissionExist(accessPermissions, 'Hide Facility') ? null : <div className='border-top d-lock mt-2'>
                        {selectedPermit?.permit_rate?.permit_rate_criteria_mapping?.length > 0 ? perkingParkingTime(selectedPermit?.permit_rate, false) : null}
                      </div>}
                    </div>
                    {/* old */}
                    {/* <div className='bg-light p-3'>
                {isPermissionExist(accessPermissions, 'Hide Facility') ? null : <h4 className="text-primary fw-bold mb-1">{facility?.full_name}</h4> }
                    <div className='row  justify-content-between g-2'>
                        <div className='col-sm col-12'>
                            <p className="m-0 small"><b className='me-2'>Entrance Address:-</b> {`${facility?.geolocations?.address_1 ? facility?.geolocations?.address_1 : ''}${facility?.geolocations?.address_2 ? `, ${facility?.geolocations?.address_2}` : ''}${facility?.geolocations?.city ? `, ${facility?.geolocations?.city}` : ''}${facility?.geolocations?.state ? `, ${facility?.geolocations?.state}` : ''}${facility?.geolocations?.zip_code ? `, ${facility?.geolocations?.zip_code}` : ''}`}</p>
                          
                            {selectedPermit?.user_type_id ? <p className='small m-0'><b>Student/Staff/Faculty ID</b><span>
                                - {selectedPermit?.user_type_id ? selectedPermit?.user_type_id: '-'}</span> </p> : ''}
                        </div>
                        {((facility?.facility_configuration && facility?.facility_configuration?.is_prorate_apply == '0')) ? <div className='col-sm-auto col-12 text-sm-end '>
                            <div className='border-top  d-block d-sm-none'></div>
                            <p className='mb-0 small'>  <span className="me-2 fw-bold d-inine-block"> Start Date: - </span>   <span><i className='fa fa-calendar-alt small me-1'></i> {prorateResponse?.start_date ? `${moment(prorateResponse?.start_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span> </p>
                            <p className='mb-0 small' >  <span className="me-2 fw-bold d-inine-block"> End Date: - </span>    <span><i className='fa fa-calendar-alt small me-1'></i> {prorateResponse?.end_date ? `${moment(prorateResponse?.end_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span></p>

                        </div> : ''
                        }


                    </div>
                    <div className='border-top d-lock mt-2'>
                        {selectedPermit?.permit_rate_criteria_mapping?.length > 0 ? perkingParkingTime(selectedPermit , false) : null}
                    </div>
                </div> */}
                    {/*  price section garage info ends */}

                    {/*  price section breakup started */}
                    <div className='secondBlock'>
                      <div className='d-flex px-3 py-2 align-items-center justify-content-between  bg-primary' >
                        <div className='text-white m-0 h5'>
                          Purchase Summary
                        </div>
                        <div className='text-white fw-bold m-0 h4'>
                          {isLoading ? <i className='fa fa-spinner fa-spin text-white'></i> : `$${(formData?.negotiated_amount && formData?.negotiated_amount != '' && Number(formData?.negotiated_amount?.replace(',', '')) > 0) ? formData?.negotiated_amount : formData?.permit_final_amount ? formData?.permit_final_amount : '0.00'}`}

                          <a className="btn ms-2 p-0 text-white border-0" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <i className='fa fa-info-circle'></i>
                          </a>
                        </div>

                      </div>

                    </div>
                    <div className="collapse show" id="collapseExample">
                      <div className="p-3">


                        <input type="radio" className='btn-check' name="permit_rate" id={'btnradio1'} autoComplete="off" onClick={(e) => handleInputFieldsData(e, 1, selectedPermit)} defaultChecked />


                        <b className='mainText'> Permit Type</b>
                        {/* <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                            <div>
                                <span className='text-muted me-2'>{selectedPermit?.permit_rate?.name ? selectedPermit?.permit_rate?.name : '-'}</span>
                                <span className="timeValidationRes col-12 small text-primary">{formData?.selectedPermitType?.[0]?.is_hide_validity == '0' && formData?.selectedPermitType?.[0]?.description ? `(${formData?.selectedPermitType?.[0]?.description})` : ''}</span>
                            </div>
                            <div className='fw-semibold mainText'>
                                <span className='d-block text-end'>{selectedPermit?.is_prorate_apply == '1' ?  `$${Number(selectedPermit?.permit_prorate?.replace(',', ''))?.toFixed(2)}` :  `$${Number(selectedPermit?.permit_rates?.replace(',', ''))?.toFixed(2)}` }</span>
                                {( (selectedPermit?.is_prorate_apply && selectedPermit?.is_prorate_apply == '1' && Number(selectedPermit?.is_prorate_apply?.replace(',', '')) > 0)) ? <span className='small text-muted fw-normal m-0 p-0'>{selectedPermit?.is_prorate_apply != '1' ? null : '(Prorated Price)'}</span> : null}
                            </div>
                        </div> */}
                        <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                          <div>
                            <span className='text-muted me-2'>{selectedPermit?.permit_rate?.name ? selectedPermit?.permit_rate?.name : '-'}</span>
                            <span className="timeValidationRes col-12 small text-primary">{formData?.selectedPermitType?.[0]?.is_hide_validity == '0' && formData?.selectedPermitType?.[0]?.description ? `(${formData?.selectedPermitType?.[0]?.description})` : ''}</span>
                          </div>
                          <div className='fw-semibold mainText'>
                            <span className='d-block text-end'>{selectedPermit?.effective_pro_rate ? `$${Number(selectedPermit?.effective_pro_rate?.replace(',', ''))?.toFixed(2)}` : '-'}</span>
                            {((selectedPermit?.is_prorate_apply && selectedPermit?.is_prorate_apply == '1' && Number(selectedPermit?.is_prorate_apply?.replace(',', '')) > 0)) ? <span className='small text-muted fw-normal m-0 p-0'>{selectedPermit?.is_prorate_apply != '1' ? null : '(Prorated Price)'}</span> : null}
                          </div>
                        </div>



                        {selectedPermit?.permit_service?.length > 0 ?
                          <div className='mb-2 border-bottom border-dashed pb-1'>
                            <b className='mainText'> Permit Services</b>
                            <div className='d-flex  px-0   w-full align-items-center justify-content-between'>

                            </div>
                            {selectedPermit?.permit_service?.map((v, i) => {
                              if (v?.permit_service_name != 'Select All Access') {
                                return (

                                  <div key={i} className='d-flex  px-0   w-full align-items-center justify-content-between'>
                                    <div>
                                      <span className=' text-muted text-capitalize'>{v?.permit_service_name}</span>
                                      <span className="d-block small text-primary">{(v?.permit_service_criteria_mappings && v?.permit_service_criteria_mappings?.length > 0) ? handlingPermitServiceCriteria(v?.permit_service_criteria_mappings) : null}</span>
                                    </div>
                                    <div className='fw-semibold '>
                                      ${v?.permit_service_rate}
                                    </div>
                                    {/* <div className='fw-semibold '>
                                      ${selectedPermit?.is_prorate_apply=='1' && v?.service_prorate ? v?.service_prorate :v?.permit_service_rate}
                                    </div> */}
                                  </div>
                                )
                              }

                            })
                            }

                          </div> : ''}

                        {formData?.discount_amount && Number(formData?.discount_amount?.replace(',', '')) > 0 ? <><b> Discount</b>
                          <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                            <div className='text-muted'>
                              Promocode Discount
                            </div>
                            <div className='fw-semibold'>
                              {`(-) $${formData?.discount_amount}`}
                            </div>
                          </div></> : null}

                        {(() => {
                          const newParkingAmount = formData?.net_parking_amount

                          const numericNew = Number(newParkingAmount?.replace(',', ''))

                          if (newParkingAmount) {
                            return (
                              <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                                <div className='text-muted'>
                                  Net Permit Amount
                                </div>
                                <div className='fw-semibold'>
                                  {`$${numericNew.toFixed(2)}`}
                                </div>
                              </div>
                            )
                          }

                          return null
                        })()}

                        {((formData?.processing_fee && Number(formData?.processing_fee?.replace(',', '')) > 0) || (formData?.additional_fee && Number(formData?.additional_fee?.replace(',', '')) > 0)) ?
                          <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                            <div className='text-muted'>
                              Processing Fee
                            </div>
                            <div className='fw-semibold'>
                              ${formData.additional_fee ? (Number(formData.additional_fee) + Number(formData.processing_fee)).toFixed(2) : Number(formData.processing_fee).toFixed(2)}
                            </div>
                          </div> : null}

                        {formData?.surcharge_fee ? <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                          <div className='text-muted'>
                            City Surcharge
                          </div>
                          <div className='fw-semibold'>
                            {`$${Number(formData?.surcharge_fee?.replace(',', ''))?.toFixed(2)}`}
                          </div>
                        </div> : null}

                        {formData?.tax_fee ? <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                          <div className='text-muted'>
                            Tax Fee
                          </div>
                          <div className='fw-semibold'>
                            {`$${Number(formData?.tax_fee?.replace(',', ''))?.toFixed(2)}`}
                          </div>
                        </div> : null}

                        {formData?.processing_fee && Number(formData?.processing_fee?.replace(',', '')) > 0 ?
                          <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                            <div className='fw-bold'>
                              Total Price
                            </div>
                            <div className='fw-bold'>
                              {isLoading ? <i className='fa fa-spinner fa-spin text-primary'></i> : `$${formData?.permit_final_amount ? formData?.permit_final_amount : '0.00'}`}
                            </div>
                          </div>
                          : null}
                      </div>
                    </div>
                  </div>


                  {/* NEW DESIGN ENDS*/}



                  {/* PURCHASE SUMMARY PROMO AND CARD DETAILS STARTS*/}
                  {(isPermissionExist(accessPermissions, 'Display Promocode') && (selectedPermit?.permit_final_amount && Number(selectedPermit?.permit_final_amount?.replace(',', '')) > 0 && (selectedPermit?.negotiated_amount == null || Number(selectedPermit?.negotiated_amount?.replace(',', '')) == 0)) || ((selectedPermit?.promocode && selectedPermit?.promocode != '') && selectedPermit?.permit_final_amount && Number(selectedPermit?.permit_final_amount?.replace(',', '')) == 0)) ? <div className="block p-3 border">
                    <div className="row">
                      <div className="col-sm-6">

                        <label htmlFor="promocode" className="form-label">Promo Code</label>

                        <div className="input-group position-relative">
                          <input
                            autoComplete="off"
                            className="form-control "
                            placeholder="Enter Promo Code"
                            name="promocode"
                            value={coupon ? coupon : formData?.promocode}
                            onChange={handleInputFieldsData}
                            type="text"
                            required=""
                            disabled={couponRemoveButton}
                          />
                          <button type="button" className="btn btn-primary d-flex align-items-center" disabled={isCouponApplied || isLoading} onClick={(e) => handleCouponCode(e)}>Apply  {isCouponLoading ?
                            <span className='ms-1'><Circles
                              height="15"
                              width="15"
                              color="#ffffff"
                              ariaLabel="circles-loading"
                              visible={true}
                            /></span> : null}
                          </button>
                          {couponRemoveButton && !isCouponAppliedAdmin && <span className="btn floatBtnCross" id="basic-addon1" onClick={handleCouponRemove}><i className='fa fa-times text-danger'></i></span>}

                        </div>
                        {formData?.coupon_applied ? <span className='text-success'>Promocode Applied</span> : null}
                      </div>


                      {couponError ? <div className='errorBlock d-inline-block'>{couponError == 'loading' ? <span className=' ms-2'><Circles
                        height="20"
                        width="20"
                        color="var(--bs-primary)"
                        ariaLabel="circles-loading"
                        visible={true}
                      /></span> : <small className='text-danger'>{couponError}</small>}
                      </div> : ''}



                    </div>

                  </div> : null}
                  {(facility?.facility_configuration && (facility?.facility_configuration && facility?.facility_configuration?.is_prorate_apply != '0')) ? <div className="card d-none">
                    <div className="card-header">
                      <b> Purchase Summary</b>
                    </div>
                    {paymentLoader && coupon ? <span className='m-5 d-flex justify-content-center'><Circles
                      height="40"
                      width="40"
                      color="var(--bs-primary)"
                      ariaLabel="circles-loading"
                      visible={true}
                    /></span> : <div className="card-body">
                      <div className="row align-items-center g-5">
                        <div className="col-12 col-sm-6">
                          <table className="table table-sm table-borderless">
                            <tbody><tr>
                              <th>
                                Price
                              </th>
                              <td>:</td>
                              <td className='text-end'>
                                <span>{prorateResponse?.effective_pro_rate ? `$${prorateResponse?.effective_pro_rate} (Prorated price)` : ''}</span>
                              </td>
                            </tr>
                              {(prorateResponse?.processing_fee && prorateResponse?.processing_fee > 0) && <tr>
                                <th>
                                  Processing Fee
                                </th>
                                <td>:</td>
                                <td className='text-end'>
                                  <span>{(prorateResponse?.processing_fee && prorateResponse?.processing_fee > 0) ? `+ $${prorateResponse?.processing_fee}` : ''}</span>
                                </td>
                              </tr>}
                              <tr>
                                <th>
                                  Start Date
                                </th>
                                <td>:</td>
                                <td className='text-end'>
                                  <span>{prorateResponse?.start_date ? `${moment(prorateResponse?.start_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span>
                                </td>
                              </tr><tr>
                                <th>
                                  End Date
                                </th>
                                <td>:</td>
                                <td className='text-end'>
                                  <span>{prorateResponse?.end_date ? `${moment(prorateResponse?.end_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span>
                                </td>
                              </tr>
                              {(isCouponApplied && prorateResponse?.promocode_discount_amount) ?
                                <tr>
                                  <th>
                                    Promo Code Discount
                                  </th>
                                  <td>:</td>
                                  <td className='text-end'>
                                    <span className="text-danger">{prorateResponse?.promocode_discount_amount ? `- $${prorateResponse?.promocode_discount_amount}` : ''}</span>
                                  </td>
                                </tr> : ''}


                            </tbody></table>


                        </div>

                        <div className="col text-end">

                          <h3 className="fw-bold m-0">Total : {prorateResponse?.total_amount ? `$${prorateResponse?.total_amount}` : ''}</h3>

                          {/* <h3 className="fw-bold m-0">Total : {prorateResponse?.total_amount ? `$${prorateResponse?.total_amount}` : ''}</h3> */}
                        </div>
                      </div>
                    </div>}
                  </div> : ''}
                  {/* <div className={selectedPermit?.total_amount ? Number(selectedPermit?.total_amount) > 0 ? 'd-inline' :Number(formData?.permitServicePrice) > 0 ? 'd-inline' : 'd-none' : 'd-none'}> */}
                  <div className={formData?.negotiated_amount ? Number(formData?.negotiated_amount) > 0 ? 'd-inline' : Number(formData?.permit_final_amount) > 0 ? 'd-inline' : 'd-none' : Number(formData?.permit_final_amount) > 0 ? 'd-inline' : 'd-none'}>

                    <div className="mt-4 px-3 border" id="accountExpand">
                      <b className="mt-0" style={{ fontSize: 'larger' }}>Payment Details</b>
                      <hr className="my-1 mb-2" />

                      {isLoggedIn() &&
                        <div className='row '>
                          {cardList?.length > 0 && <div className="col-sm-6">
                            <div className="mb-3">
                              <select name="vehicle" id="vehicle" disabled={isCardFormVisible} className="form-select" onChange={handleCardSelectChange} >
                                <option>Select Card</option>
                                {cardList?.map((card, index) => {
                                  return (
                                    <option value={card?.payment_profile_id} selected={card?.payment_profile_id == formData?.payment_profile_id} key={index}>{`XXXX XXXX XXXX ${card?.card_last_four?.slice(0, 4) ? card?.card_last_four?.slice(0, 4) : 'XXXX'} (${card?.expiry?.slice(0, 2) ? card?.expiry?.slice(0, 2) : '-'}/${card?.expiry?.slice(2, 4) ? card?.expiry?.slice(2, 4) : '-'})`}</option>
                                  )
                                })}
                              </select>
                              <span className="form-text text-danger h-40">{formError == 'paymentPermitRequest' && !isCardFormVisible && (!formData?.payment_profile_id && !formData?.card_pan) ? 'Please select or add new card' : ''}</span>
                            </div>
                          </div>}

                          {cardList?.length > 0 && !isCardFormVisible ? <div className='col-sm-6 mb-3'>{cardList?.length > 0 && <span className='badge badge-primary text-dark fw-bold me-2'>OR</span>}<button className='btn btn-primary' type="button" onClick={showCardForm}><i className='fa fa-plus'></i> Add New Card</button></div> : cardList?.length > 0 && <div className='col-sm-6 mb-3'><span className='badge badge-primary text-dark fw-bold me-2'>OR</span>  <button className='btn btn-danger' type="button" onClick={hideCardForm}>Select Existing Card</button></div>}

                        </div>}
                      {(isCardFormVisible) && facility?.facility_payment_details?.facility_payment_type_id != '3' ?

                        <div>
                          <div className="row">
                            <div className="col-sm-6 ">
                              <div className="mb-3">
                                <label htmlFor="Name on Card" className="form-label">Name on Card <span className='text-danger'> *</span></label>
                                <input
                                  onChange={handleInputFieldsData}
                                  autoComplete="off"
                                  name='name'
                                  className="form-control "
                                  maxLength={20}
                                  minLength={1}
                                  placeholder="Name on Card"
                                  type="text"
                                  required="" />
                                <span className="form-text text-danger h-40">{formError == 'paymentPermitRequest' && !formData?.name ? 'This field is required' : ''}</span>
                              </div>
                            </div>

                            <div className="col-sm-6 col-md-6">
                              <div className="mb-3">
                                <label htmlFor="Card Number" className="form-label">Card Number <span className='text-danger'> *</span>
                                </label>
                                <MaskedInput
                                  maskGenerator={cardnumbermask}
                                  value={card}
                                  type="text"
                                  name="card_pan"
                                  id="card_pan"
                                  required={true}
                                  pattern="[0-9 ]{18,19}"
                                  maxLength='19'
                                  minLength='18'
                                  title="Card no. should be 15-16 digit numeric"
                                  className="form-control"
                                  onChange={handleCardChange}
                                  placeholder="Card Number"
                                />
                                <span className="form-text text-danger h-40">{formError == 'paymentPermitRequest' ? !formData?.card_pan ? 'This field is required' : validateCardNumber(formData?.card_pan) ? '' : '' : ''}</span>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 col-md-6">
                              <div className="mb-3">
                                <label htmlFor="Card Number" className="form-label">Card Expiry <span className='text-danger'> *</span>
                                </label>
                                <MaskedInput
                                  maskGenerator={expirymask}
                                  value={expiry}
                                  type="text"
                                  autoComplete="off"
                                  name="expiration_date"
                                  id="expiration_date"
                                  required={true}
                                  pattern="[0-9 ]{4}"
                                  maxLength='5'
                                  minLength='4'
                                  title="Enter a valid expiry date"
                                  className="form-control"
                                  onChange={handleExpiryChange}
                                  onInvalid={e => e.target.setCustomValidity('Please enter a valid expiry date')}
                                  onInput={e => e.target.setCustomValidity('')}
                                  placeholder="MM/YY"
                                />

                                <span className="form-text text-danger h-40">{formError == 'paymentPermitRequest' ? !formData?.expiration_date ? 'This field is required' : '' : ''}</span>
                                {/* <span className="form-text text-danger h-40">{formError == 'paymentPermitRequest' ? formData?.expiration_date && (formData?.expiration_date?.length<4 || formData?.expiration_date?.length>5)? 'Enter a valid expiry date ':'' : ''}</span> */}
                                <span className='form-text text-danger h-40'>{cardExpiryMessage}</span>

                              </div> </div>

                            {/* <div className="col-sm-4 col-6 mb-3">
                                    <label htmlFor="Expiry Month" className="form-label">Expiry Month <span className='text-danger'> *</span></label>
                                    <select
                                        name='card_date_expiry_month'
                                        id="card_date_expiry_month"
                                        required=""
                                        className="form-select"
                                        onChange={handleInputFieldsData}
                                        value={formData?.card_date_expiry_month}
                                    >
                                        <option value="">Expiry Month</option>
                                        {EXPIRY_MONTHS.map((item, key) => <option key={key} value={item}>{item}</option>)}
                                    </select>
                                    <span className="form-text text-danger h-40">{formError == 'paymentPermitRequest' && !formData?.card_date_expiry_month ? 'This field is required' : ''}</span>
                                </div>

                                <div className="col-sm-4 col-6 mb-3">
                                    <label htmlFor="Expiry Year" className="form-label">Expiry Year<span className='text-danger'> *</span></label>

                                    <select
                                        name='card_date_expiry_year'
                                        id='expiryYear'
                                        required=""
                                        className="form-select"
                                        onChange={handleInputFieldsData}
                                        value={formData?.card_date_expiry_year}
                                    >
                                        <option value="">Expiry Year</option>
                                        {EXPIRY_YEARS.map((item, key) => <option key={key} value={item.val}>{item.label}</option>)}
                                    </select>
                                    <span className="form-text text-danger h-40">{formError == 'paymentPermitRequest' && !formData?.card_date_expiry_year ? 'This field is required' : ''}</span>

                                </div> */}

                            <div className="col-sm-6 col-md-6">
                              <div className="mb-3">
                                <label htmlFor="" className="form-label">CVV <span className='text-danger'> *</span></label>
                                <input
                                  onChange={handleInputFieldsData}
                                  autoComplete="off"
                                  className="form-control"
                                  id="standardCardCvv"
                                  maxLength="4"
                                  name="card_card_security_cvx_2"
                                  placeholder="CVV / Security Code"
                                  type="password"
                                  onKeyPress={(e) => restrictInputValues(e)}

                                  required=""
                                />
                                <span className="form-text text-danger h-40">{formError == 'paymentPermitRequest' && !formData?.card_card_security_cvx_2 ? 'This field is required' : ''}</span>
                              </div>
                            </div></div>
                          <div className="row">

                            <div className="col-sm-4">
                              <div className="mb-3">
                                <label htmlFor="" className="form-label">Zip Code </label>
                                <input
                                  onChange={handleInputFieldsData}
                                  className="form-control "
                                  maxLength="6"
                                  minLength="5"
                                  name="zip_code"
                                  pattern="[0-9]{5,6}"
                                  placeholder="Billing Address Zip Code"
                                  onKeyPress={(e) => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? restrictSpecialChar(e) : restrictInputValues(e)}

                                  type="text"
                                  required=""
                                />
                                <span className="form-text text-danger h-40">**Mandatory for Amex Cards only</span>
                                {/* <span className="form-text text-danger h-40">{formError == 'paymentPermitRequest' && !formData?.zip_code ? 'This field is required' : ''}</span> */}
                              </div>
                            </div>
                          </div>


                          <input type='hidden' name='XXX_IPG_XXX' id='XXX_IPG_XXX' value='confirm' />
                          <input type='hidden' name='XXX_IPGTRXNO_XXX' id='XXX_IPGTRXNO_XXX' value={guidValue} />
                          <input type='hidden' name='XXX_IPGSESSION_XXX' id='XXX_IPGSESSION_XXX' value={resValue}></input>
                        </div>
                        : (!isLoggedIn() || isCardFormVisible) ?
                          <CardConnectTokenizer
                            setToken={setCardToken}
                            faciltyPaymentDetails={facility?.facility_payment_details}
                            setIframeErrorMessage={setIframeErrorMsg}
                            tokenRef={tokenRef}
                          /> : null}
                    </div>

                  </div>
                  {/* PURCHASE SUMMARY PROMO AND CARD DETAILS */}
                  {/* 
                  <div className=' my-2 px-3' >
                        
                    </div> */}

                  <div className='border p-3 my-2' >
                    <div className="form-check">
                      <input disabled={Number(formData?.permit_final_amount?.replace(',', '')) <= 0 ? true : false} className="form-check-input" type="checkbox" id="userConsent" name="userConsent" onClick={(e) => handleConsentChange(e)} checked={isConsent} />
                      {/* defaultChecked={isConsent} */}
                      <small>By clicking this button, you are providing your consent for auto renewal of the permit {formData?.isPermitPurchase == '0' ? 'if approved.' : formData?.isPermitPurchase == '1' ? '.' : ''}</small>
                    </div>

                    {isPermissionExist(accessPermissions, 'Display Terms & Conditions') ? <div className="form-check">
                      <input className="form-check-input" type="checkbox" id="userAcknowledge" name="userAcknowledge" required onClick={(e) => handleAcknowledge(e)} checked={formData?.userAcknowledge} />
                      <small>I have read and agreed to the {partnerDetails?.term_condition_heading ? partnerDetails?.term_condition_heading : 'ParkEngage'}  <a href='javascript:;' onClick={handleModalTerm}>Terms & Conditions</a>.</small>
                      <span className="form-text text-danger h-40 d-block">{formError == 'paymentPermitRequest' && !formData?.userAcknowledge ? 'Please provide your acknowledgement on above Terms and Conditions.' : ''}</span>

                    </div> : null}
                    <button id="next-btn" type="button" className="btn btn-primary d-flex step-btn" onClick={() => handleSubmit(formData)} disabled={isLoading}>Submit {isLoading ? <span className=' ms-2'><Circles
                      height="20"
                      width="20"
                      color="#ffffff"
                      ariaLabel="circles-loading"
                      visible={true}
                    /></span> : null}</button>
                    {(Number(formData?.permit_final_amount) > 0 && walletButtonShow && ((formData?.userAcknowledge && isPermissionExist(accessPermissions, 'Display Terms & Conditions')) || !isPermissionExist(accessPermissions, 'Display Terms & Conditions'))) ? <>
                      <div className="my-3 fw-bold text-center">- OR -</div>
                      <div className='d-flex justify-content-center'>
                        <div className='position-relative'>
                          {(walletDisable || isLoading) ? <div className='overlay-opacity'>&nbsp;</div> : null}
                          <WalletButtons faciltyData={currFacility} getValues={getVals} onSubmit={handleSubmit} isSubmittingForm={isLoading} setIsSubmittingForm={setIsLoading} setIsLoading={setIsLoading} payableAmount={formData?.permit_final_amount ? formData?.permit_final_amount : 0} notify={notify} isIOSDevice={isIOSDevice} applePaySessionRef={applePaySessionRef} />
                        </div>
                      </div>
                      <small className='border border-danger p-2 rounded-3 text-center text-small text-danger small w-100'>By using Apple pay/Gpay, the permit can not be auto renewed.</small>
                    </> : ''}
                  </div>
                </div> : null}
              {page == 'thankyou' ? <div className='mt-5 pt-5'>
                <ThankYou response={response} paymentStatus={paymentStatus} paymentResponse={paymentResponse} isLoading={isLoading} />
              </div> : null}
            </form>
          </div>}
      </div>
    </div>

  )
}

paymentPermitRequest.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.object,
  events: PropTypes.object,
  loader: PropTypes.bool,
  getCard: PropTypes.func,
  paymentPermitRequestData: EMPTY_ARRAY,
  setPage: PropTypes.string,
  idProof: PropTypes.object,
  rateList: PropTypes.object,
  paymentLoader: PropTypes.bool,
  formData: PropTypes.object,
  setFormData: PropTypes.func,
  formError: PropTypes.string,
  guidValue: PropTypes.string,
  resValue: PropTypes.string,
  partnerDetails: PropTypes.object,
  notify: PropTypes.func,

}

paymentPermitRequest.defaulProps = {
  dispatch: noop,
  data: EMPTY_OBJECT,
  events: EMPTY_OBJECT,
  loader: PropTypes.bool,
  getCard: PropTypes.func,
  paymentPermitRequestData: EMPTY_ARRAY,
  setPage: undefined,
  idProof: EMPTY_OBJECT,
  rateList: EMPTY_OBJECT,
  paymentLoader: false,

  formError: undefined,
  guidValue: '',
  resValue: '',
  partnerDetails: EMPTY_OBJECT,
  notify: noop,

}

function mapStateToProps({ paymentReducer, basicInfoReducer, PartnerReducer }) {
  return {
    data: paymentReducer,
    paymentLoader: paymentReducer?.proRateLoader,
    rateList: basicInfoReducer.rateList.data,
    partnerDetails: PartnerReducer?.partnerDetails?.data,
  }
}
export default connect(mapStateToProps)(paymentPermitRequest)